export default class PatientVaccine {
    id=""
    vaccine={}
    dateVaccine=""
    lote=""
    responsable=""
    patientRouteSheet=""
}


// WEBPACK FOOTER //
// ./src/model/PatientVaccine.js